import { DownloadLinkOutput, SIDE } from '@allocab/allocab-commons-shared-types';
import { useQuery } from '@tanstack/react-query';

import { queryKeys } from '../services/datastore/queryKeys';
import { DEFAULT_CACHE_TIME, silentQueryErrorHandler } from '../services/datastore/react-query';
import { driverApi } from '../services/network/Api';

type Input = { side: SIDE; driverKey?: string };

const fetchDocumentLink = (documentId: string | undefined, input: Input) =>
  driverApi.get<Input, DownloadLinkOutput>(`/v1/document/link-download/${documentId}`, input);

export const useFetchDocumentLink = (documentId: string | undefined, input: Input) =>
  useQuery(queryKeys.user.fetchDocumentLink(documentId, input), () => fetchDocumentLink(documentId, input), {
    enabled: !!documentId,
    staleTime: DEFAULT_CACHE_TIME,
    onError: silentQueryErrorHandler,
  });
